export default function TabPanel(props) {
  const isActive = props.value === props.index;
  
  return (
    <div
      hidden={!isActive}
      className={props.className || ''}
      style={{ width: '100%', boxSizing: 'border-box', ...(props.style || {}) }}
    >
      {(props.doNotRenderOnHidden && !isActive) ? null : props.children}
    </div>
  );
}